<ng-template #navItems>
  <li class="nav-item" (click)="onIconClick()">
    <a class="nav-link" routerLinkActive="active" [routerLink]="[ '/filialen' ]" title="Filialfinder" aria-label="Filialfinder">
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="none" viewBox="0 0 32 32" aria-hidden="true" focusable="false">
        <path stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M28 13.334c0 9.333-12 17.333-12 17.333s-12-8-12-17.333a12 12 0 1 1 24 0Z"/>
        <path stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 17.334a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"/>
      </svg>
    </a>
  </li>
  <li class="nav-item" (click)="onIconClick()">
    <a class="nav-link" [class.active]="currentRouteSegment() == '/customer'" title="Kundenbereich">
      <gea-shop-login-button></gea-shop-login-button>
    </a>
  </li>
  <li class="nav-item" (click)="onIconClick()">
    <a class="nav-link cart" routerLinkActive="active" [routerLink]="[ '/checkout' ]" title="Kassa" aria-label="Kassa">
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" aria-hidden="true" focusable="false">
        <path stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 29.333a1.333 1.333 0 1 0 0-2.666 1.333 1.333 0 0 0 0 2.666ZM26.667 29.333a1.333 1.333 0 1 0 0-2.666 1.333 1.333 0 0 0 0 2.666ZM1.334 1.333h5.333l3.574 17.854a2.666 2.666 0 0 0 2.666 2.146h12.96a2.667 2.667 0 0 0 2.667-2.146L30.667 8H8.001"/>
      </svg>
      @if (cartItemsCount()) {
        <div class="cart-items-count" [class.digits]="cartItemsCount() > 9">
          <svg class="count" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33 33" fill="none">
            <circle cx="16.5" cy="16.5" r="16.5" fill="#00923F"/>
          </svg>
          <span class="counter">{{ cartItemsCount() }}</span>
        </div>
      }
    </a>
  </li>
  <li class="nav-item">
    <span class="nav-link" role="button" tabindex="0" (click)="onToggle()" (keydown.enter)="onToggle()" (keydown.space)="onToggle()" [attr.aria-expanded]="! isMegaMenuCollapsed()" data-bs-toggle="collapse" aria-label="Navigation öffnen" data-bs-target="#megamenu" aria-controls="megamenu">
      <svg height=23 viewBox="0 0 22 17" xmlns="http://www.w3.org/2000/svg">
        <line x1=2 y1=2 x2=20 y2=2 stroke="black" stroke-width="1.3" />
        <line x1=2 y1=9 x2=20 y2=9 stroke="black" stroke-width="1.3" />
        <line x1=2 y1=16 x2=20 y2=16 stroke="black" stroke-width="1.3" />
      </svg>
    </span>
  </li>
</ng-template>

@let mc = mainCategories();

<nav class="navbar text-nowrap navbar-light navbar-expand-lg" #navbar>
  <div class="container position-relative">
    <a class="navbar-brand" href="/" aria-label="Gea Waldviertler - zur Startseite"><img src="assets/logo-gea.png" alt=""/></a>
    <ul class="mobile-navicons">
      <ng-container *ngTemplateOutlet="navItems"></ng-container>
    </ul>
    <div class="navbar-collapse collapse" [class.show]="! isMenuCollapsed" id="navbarSupportedContent">
      <div class="d-flex justify-content-between w-100">
        @if (mc) {
          <ul class="navbar-nav main-categories">
            @for (category of mc; track category) {
              <li class="nav-item">
                <a class="nav-link" routerLinkActive="active"
                [routerLink]="[ '/' + category.nodePath ]"> {{ category.name }} </a>
              </li>
            }
          </ul>
        }
        <ul class="navbar-nav right-menu">
          <li class="nav-item w-50">
            <gea-shop-search-field />
          </li>
          <ng-container *ngTemplateOutlet="navItems"></ng-container>
        </ul>
      </div>
    </div>
    <gea-shop-add-to-cart-popup></gea-shop-add-to-cart-popup>
  </div>
</nav>

@let cr = cmsResponse();

@if (cr) {
  <nav id="megamenu" class="pb-3 collapse" [class.show]="! isMegaMenuCollapsed()">
    <div class="mobile-search container">
      <gea-shop-search-field />
    </div>
    @if (isBrowser()) {
      <div class="content d-lg-none">
        @if (cr.header.main_nav_links) {
          <div ngbAccordion [closeOthers]="false">
            @for (groupLink of cr.header.main_nav_links; track groupLink) {
              <div ngbAccordionItem [collapsed]="! (mc && groupLink.target_url.endsWith('/shop/') && inShop())">
                <h2 ngbAccordionHeader>
                  <button ngbAccordionButton>{{ groupLink.heading }}</button>
                </h2>
                <div ngbAccordionCollapse>
                  <div class="link-wrap lvl1">
                    <a class="accordion-button" routerLinkActive="active" href="{{ groupLink.target_url }}">
                      {{ groupLink.heading }} entdecken
                    </a>
                  </div>
                  @if (mc && groupLink.target_url.endsWith('/shop/')) {
                    <gea-shop-navigation-category-accordion
                      [level]=1 [categories]="mc"
                      />
                  }
                  <div ngbAccordionBody>
                    @for (navLink of groupLink.linkGroups; track navLink) {
                      @for (itemLink of navLink; track itemLink) {
                        @if (! ['/shop/schuhe', '/shop/taschen', '/shop/mobel', '/shop/divers'].includes(itemLink.url)) {
                          <div class="link-wrap lvl1"
                            >
                            <a class="accordion-button" routerLinkActive="active" href="{{ itemLink.url }}">
                              {{ itemLink.text }}
                            </a>
                          </div>
                        }
                      }
                    }
                  </div>
                </div>
              </div>
            }
          </div>
        }
      </div>
    }
    <div class="container d-none d-lg-block">
      <div class="content">
        @for (groupLink of cr.header.main_nav_links; track groupLink) {
          <div class="section">
            <div class="py-4 group">
              <a href="{{ groupLink.target_url }}">{{ groupLink.heading }}</a>
            </div>
            <div class="expander pe-1">
              <ul class="py-4">
              @for (navLink of groupLink.linkGroups; track navLink) {
                  @for (itemLink of navLink; track itemLink) {
                    <li>
                      <a class="d-block pb-3 nav-link" href="{{ itemLink.url }}">{{ itemLink.text }}</a>
                    </li>
                  }
              }
              </ul>
            </div>
          </div>
        }
      </div>
    </div>
  </nav>
}

<gea-shop-search-results />

@let bcs = breadcrumbs();

@if (isMegaMenuCollapsed() && bcs && bcs.length) {
  <nav aria-label="breadcrumb" class="breadcrumbs" #breadcrumb>
    <div class="container">
      <ol class="breadcrumb">
        @for (bc of bcs; track bc; let i = $index) {
          <li class="breadcrumb-item"
            [class.active]="i == bcs.length">
            <a [routerLink]="[ bc.link ]">{{ bc.label }}</a>
          </li>
        }
      </ol>
      <!-- Buttons -->
      @let btns = buttons();
      @if (btns) {
        <div class="breadcrumb button-container">
          @for (btn of btns; track btn) {
            <button
              type="{{btn.type ? btn.type : 'button'}}"
              class="btn {{btn.class}}"
              (click)="btn.onClick()">{{btn.text}}
            </button>
          }
        </div>
      }
    </div>
  </nav>
}